/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface HardBlockedView {
  job_candidate_id: string;
  full_name?: string | null;
  missing_fields?: string[];
  block_codes?: string[];
  application_questions_soft_hint?: boolean;
}
